<template>
  <svg
    v-bind="$attrs"
    @click.prevent="$emit('click')"
  >
    <use :xlink:href="`/symbols.svg#${icon}`" />
  </svg>
</template>

<script>
export default {
    name: 'BaseIcon',
    props: {
        icon: { type: String, required: true },
    },
};
</script>
